// Выбранный workspace — клиентское состояние вкладки.
//
// Хранится в localStorage и уезжает на бэкенд заголовком `X-Workspace-Id`.
// Заголовок — способ ВЫБОРА, а не доказательство доступа: членство всё равно
// проверяется в `withScope` (guide §7), поэтому подделка значения даёт 403,
// а не чужие данные.
//
// Доступ к localStorage завёрнут в try/catch: в Safari private mode и в
// jsdom-тестах обращение может бросить, и падать из-за этого шапка не должна.

const STORAGE_KEY = 'govard.crm.active-workspace';
const memoryStorage: Record<string, string> = {};

export function readActiveWorkspaceId(): string | null {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const value = window.localStorage.getItem(STORAGE_KEY);
      return value !== null && value.length > 0 ? value : null;
    }
  } catch {
    // fallback to memory
  }
  return memoryStorage[STORAGE_KEY] ?? null;
}

export function writeActiveWorkspaceId(workspaceId: string | null): void {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      if (workspaceId === null) {
        window.localStorage.removeItem(STORAGE_KEY);
      } else {
        window.localStorage.setItem(STORAGE_KEY, workspaceId);
      }
    }
  } catch {
    // fallback to memory
  }
  if (workspaceId === null) {
    delete memoryStorage[STORAGE_KEY];
  } else {
    memoryStorage[STORAGE_KEY] = workspaceId;
  }
}
